import { ExternalLink } from "lucide-react";
import { CONCERNS } from "@/lib/content";
import { SectionHeading, MethodTag } from "./Primitives";

const Block = ({ label, text }) => (
  <div>
    <p className="mono uppercase tracking-[0.14em] text-sec">{label}</p>
    <p className="mt-1.5 text-[15px] leading-relaxed text-ink">{text}</p>
  </div>
);

export const Concerns = () => (
  <section className="bg-white py-16 sm:py-28 rule" id="concerns" data-testid="concerns-section">
    <div className="container-x">
      <SectionHeading
        title="What can go unnoticed."
        lead="A home can look immaculate and still have air and water you’ve never measured. Three specific, well-documented concerns, and what measurement adds."
        testId="concerns-heading"
      />
      <div className="mt-12 sm:mt-16 grid gap-14 md:grid-cols-3 md:gap-8 lg:gap-12">
        {CONCERNS.map((c) => (
          <article key={c.id} data-testid={`concern-${c.id}`}>
            <figure className="aspect-[4/5] overflow-hidden rounded-md">
              <img src={c.image} alt={c.alt} loading="lazy" className="h-full w-full object-cover" />
            </figure>
            <div className="mt-6 flex flex-wrap items-center gap-2">
              <MethodTag kind={c.method} />
              <span className="mono text-sec">{c.location} · {c.unit}</span>
            </div>
            <h3 className="h-editorial !text-2xl sm:!text-3xl mt-4">{c.title}</h3>
            <div className="mt-6 space-y-5 border-t border-divider pt-6">
              <Block label="Possible source" text={c.affects} />
              <Block label="What we measure" text={c.measure} />
              <Block label="What you learn" text={c.learn} />
            </div>
            <a href={c.source.url} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-sec hover:text-ink min-h-[44px]" data-testid={`concern-source-${c.id}`}>
              {c.source.label} <ExternalLink size={12} />
            </a>
          </article>
        ))}
      </div>
    </div>
  </section>
);
